const directionPageArr = [
  { 
      page: "global",
      menu: 'userMenu',
      header: 'userHeader',
      footer: 'globalFooter'
  },
  {
      page: "ContactsList",
      menu: "optionsMenu",
  },
  {
      page: "ContactsHome",
      menu: "optionsMenu",
  },
  {
      page: "ContactsCreate",
      menu: "optionsMenu",
  },
  {
      page: "ContactsUpdate",
      menu: "optionsMenu",
  },
  {
      page: "ContactsDetail",
      menu: "optionsMenu",
  },
  {
      page: "SliderList",
      menu: "optionsMenu",
  },
  {
      page: "SliderCreate",
      menu: "optionsMenu",
  },
  {
      page: "SliderUpdate",
      menu: "optionsMenu",
  },
  {
      page: "SliderDetail",
      menu: "optionsMenu",
  },
  {
      page: "SinifList",
      menu: "optionsMenu",
  },
  {
      page: "SinifCreate",
      menu: "optionsMenu",
  },
  {
      page: "SinifUpdate",
      menu: "optionsMenu",
  },
  {
      page: "SinifDetail",
      menu: "optionsMenu",
  },
  {
      page: "DersList",
      menu: "optionsMenu",
  },
  {
      page: "DersCreate",
      menu: "optionsMenu",
  },
  {
      page: "DersUpdate",
      menu: "optionsMenu",
  },
  {
      page: "DersDetail",
      menu: "optionsMenu",
  },
  {
      page: "FilesList"
  },
  {
      page: "FilesCreate",
      menu: "optionsMenu",
  },
  {
      page: "FilesUpdate",
      menu: "optionsMenu",
  },
  {
      page: "FilesDetail"
  },
  {
      page: "UnitsList"
  },
  {
      page: "UnitsCreate",
      menu: "optionsMenu",
  },
  {
      page: "UnitsUpdate",
      menu: "optionsMenu",
  },
  {
      page: "UnitsDetail",
      menu: false,
   },
  {
      page: "HomePage",
      menu: false
  },
  {
      page: "UsersSignIn",
      menu: false
  },
  {
      page: "UsersList",
      menu: "optionsMenu",
  },
  {
      page: "UsersLogin",
      menu: false
  },
  {
      page: "UsersForgotPassword",
      menu: false
  },
  {
      page: "TosPage",
      menu: "questMenu"
  },
  {
      page: "PrivacyPage",
      menu: "questMenu"
  },
  {
      page: "CookiePolicyPage",
      menu: "questMenu"
  },
  {
      page: "ContactPage",
      menu: "questMenu"
  },
  {
      page: "ErrorPage",
      menu: false
  },
  {
      page: "Error404",
      menu: false
  },
  {
      page: "AdminHome",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSettings",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSiteSettings",
      menu: "adminMenu",
      header: "adminHeader", 
      footer: "adminFooter"
  },
  {
      page: "AdminUsers",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminAnalytics",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminLogs",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchema",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchemaCreate",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchemaUpdate",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchemaDetail",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminContacts",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "TasksHome",
      menu: "optionsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksCreate",
      menu: "optionsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksUpdate",
      menu: "optionsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksDetail",
      menu: "optionsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksList",
      menu: "optionsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksSearch",
      menu: "optionsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "KanbanBoard",
      menu: "optionsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "CalendarView",
      menu: "optionsMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "OptionsHome",
      menu: "optionsMenu"
  },
  {
      page: "StudentsCreate",
      menu: true,
      header: true,
      footer: true
  },
  {
      page: "StudentsCreateExcel",
      menu: true,
      header: true,
      footer: true
  },
  {
      page: "GeminiDemo",
      menu: "optionsMenu",
      header: "userHeader",
      footer: "globalFooter"
  }
];

export default directionPageArr;
